interface DialogParams {
    title?: string; // 标题
    msg: string; // 内容
    buttons: string[]; // 按钮 数组数量为1则为alert，为2则为confirm
    /**
     * 回调函数
     * 回调参数 类型josn
     * index: number 被点击按钮对应buttons的位置 默认值：0
     */
    callback?: string | ((res: any) => void);
}

interface previewImageParams {
    current: number; // 当前图片所在位置
    urls: string[]; // 需要预览的图片http链接列表
}

interface shareParams {
    title: string; // 分享标题
    desc: string; // 分享描述
    link: string; // 分享链接
    imgUrl: string; // 分享图标
    type?: string; // 分享类型(image、link)  默认值：link
    origin: string; // 分享源(None: 打开分享选择; Timeline: 朋友圈; Weixin: 微信好友; Qzone: QQ空间; QQ: QQ好友; Weibo: 新浪微博) 默认值：None
    dataUrl?: string; // 如果type是image，则要提供base64格式的图片地址，并将地址处理为(url.split(';base64,')[1])
    /**
     * 回调函数
     * 回调参数 类型josn
     * origin: string 分享渠道; status: string 分享状态[分享成功：success或者1，分享取消：cancel或者0]
     */
    callback?: string | ((res: any) => void);
}

interface onshareParams {
    title: string; // 分享标题
    desc: string; // 分享描述
    link: string; // 分享链接
    imgUrl: string; // 分享图标
    /**
     * 回调函数
     * 回调参数 类型josn
     * origin: string 分享渠道; status: string 分享状态[分享成功：success或者1，分享取消：cancel或者0]
     */
    callback?: string | ((res: any) => void);
}

interface OpenLoginParams {
    /**
     * 回调函数
     * 回调参数 类型josn 用户信息
     * 包含device_id(设备唯一标识)、avatar(头像)、mobile(电话号码)、nickname(昵称)、token(token)
     */
    callback?: string | ((res: any) => void);
}

interface GetUserParams {
    /**
     * 回调函数
     * 回调参数 类型josn 用户信息
     * 包含device_id(设备唯一标识)、avatar(头像)、mobile(电话号码)、nickname(昵称)、token(token)等
     */
    callback: string | ((res: any) => void);
}

interface bindMobileParams {
    /**
     * 回调函数
     * 回调参数 类型josn
     * status: string 分享状态[分享成功：success]
     */
    callback?: string | ((res: any) => void);
}

interface wxAuthorizeParams {
    /**
     * 回调函数
     * 回调参数 类型josn
     * status: string 分享状态[状态，1-成功，0-失败]
     * openid: string 微信的openid
     */
    callback: string | ((res: any) => void);
}

interface goVideoCaptureParams {
    topicId: number; // 话题id
    topicName: string; // 话题名称
    /**
     * 回调函数
     * 回调参数 类型josn
     * status: string 发布状态[状态，1-成功]
     */
    callback?: string | ((res: any) => void);
}

interface goVideoPlayParams {
    id: number | string; // 动态id
    url: string; // 视频地址
}

interface copyToClipboradParams {
    text: string; // 复制的文本
    /**
     * 回调函数
     * 回调参数 类型josn
     * status: string 状态[状态，success-成功]
     */
    callback?: string | ((res: any) => void);
}

interface shareImageParams {
    title: string; // 分享标题
    desc: string; // 分享描述
    link: string; // 分享链接
    imgUrl: string; // 分享图标
    image: string; // 提供base64格式的图片地址，并将地址处理为(url.split(';base64,')[1])
    /**
     * 回调函数
     * 回调参数 类型josn
     * origin: string 分享渠道; status: string 分享状态[分享成功：success或者1，分享取消：cancel或者0]
     */
    callback?: string | ((res: any) => void);
}

interface getNotificationStatusParams {
    /**
     * 回调函数
     * 回调参数 类型josn
     * status: string 状态[通知打开：1; 通知未打开：0]
     */
    callback: string | ((res: any) => void);
}

interface integralParams {
    /**
     * 绑定手机 1；签到 2；邀请好友 3；看新闻 4；看视频 5；看直播 6；播放音频 7；分享 8；发表评论 9；收藏文章 10；链接分享 11；
     * 关注 100；发表动态 101；看报料视频 106；加入圈子 108；互动 110；点赞 111
     * 回调参数 类型josn
     * status: string 状态[通知打开：1; 通知未打开：0]
    */
    type: number; 
    /**
     * 回调函数
     * 回调参数 类型josn
     * status: string 状态[通知打开：1; 通知未打开：0]
    */
    callback?: string | ((res: any) => void);
}

let callBackNo: number = 0;
let readyFnList: any[] = [];
function generateFnName (): string {
	callBackNo++;
	return 'COVERAPP_CallBack_' + callBackNo;
}
let COVERAPP = {
	// 基础属性类
	Attribute: {
		// userAgent
		UA: navigator.userAgent,

		// version
		version: '1.4.0',

		// 判断是否为app
		isApp (): boolean {
			let ua = this.UA;
	    	if (/TheCover/i.test(ua)) {
	      		return true;
	    	}
	        return false;
		},

		// 判断是否是ios
		isIOS (): boolean {
			let ua = this.UA;
		    if (/ios/i.test(ua) || /iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
		       return true;
		    }
		    return false;
		},

		// 判断是否是android
	    isAndroid (): boolean {
	    	let ua = this.UA;
	    	if (/android/i.test(ua)) {
	      		return true;
	    	}
	        return false;
	    },

	    // 获取客户端版本号
	    appVersion (): number {
	    	let ua = this.UA;
            let version = ua.split('(TheCover_')[1].split('_')[0];
            return parseInt(version.split('.').join(''));
	    },

	    // 获取系统类型
	    systemType (): string {
	    	let ua = this.UA;
	    	let sys = ua.split('(TheCover_')[1].split('_')[1];
	    	return sys;
	    },

	    // 设备标识
	    deviceId (): string {
	    	let ua = this.UA;
	    	let id = ua.split('(TheCover_')[1].split('_')[2].split(')')[0]
	    	return id;
		},
		
		// 判断是否是微信
		isWeixin (): boolean {
			let ua = this.UA;
			if (/MicroMessenger/i.test(ua)) {
				return true;
			}
			return false;
		},

		// 判断是否是手Q
		isQQ (): boolean {
			let ua = this.UA;
			if (/qq/i.test(ua)) {
				return true;
			}
			return false;
		},

		// 是否是支付宝
		isAlipay (): boolean {
			let ua = this.UA;
			if (/alipay/i.test(ua)) {
				return true;
			}
			return false;
		}
	},

	// 界面类
	UI: {
		// 对话框
		Dialog (obj: DialogParams): void {
            if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.Dialog.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.dialog(JSON.stringify(obj));
			}			
		},

		// 图集预览
		previewImage (obj: previewImageParams): void {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.PreviewImage.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.previewImage(JSON.stringify(obj));
			}
		}
	},

	// 功能方法类
	Method: {
		// 分享
		Share (obj: shareParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.Share.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.share(JSON.stringify(obj));
			}		
		},

		// 被动分享
		onshare (obj: onshareParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.onShare.postMessage(obj);
			} else {
				window.AndroidBridging.onShare(JSON.stringify(obj));
			}
		},

		// 打开登录
		OpenLogin (obj: OpenLoginParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.Login.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.login(JSON.stringify(obj));
			}	
		},

		// 获取用户信息
		GetUser (obj: GetUserParams): void {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				// 老版本User，新版本wcUser
				window.webkit.messageHandlers.wcUser.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				// 老版本user，新版本wcuser
				window.AndroidBridging.wcuser(JSON.stringify(obj));
			}
		},

		// 获取通知是否打开 callback 必传
		getNotificationStatus (obj: getNotificationStatusParams): void {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.getNotificationStatus.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.getNotificationStatus(JSON.stringify(obj));
			}
		},

		// 去设置页面
		goSettingNotification (): void {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goSettingNotification.postMessage('');
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.goSettingNotification();
			}
		},

		/**
		 * 调起绑定手机号
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		bindMobile (obj: bindMobileParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.bindMobile.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.bindMobile(JSON.stringify(obj));
			}
		},

		// 获取微信openid
		wxAuthorize (obj: wxAuthorizeParams): void {
			let funName = generateFnName();
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.wxAuthorize.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.wxAuthorize(JSON.stringify(obj));
			}
		},

		// 进入发布动态图文或视频选择页
		goVideoCapture (obj: goVideoCaptureParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goVideoCapture.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.goVideoCapture(JSON.stringify(obj));
			}
		},

		// 安卓视频播放
		goVideoPlay (obj: goVideoPlayParams): void {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goVideoPlay.postMessage(obj);
			} else if(COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.goVideoPlay(JSON.stringify(obj));
			}
			
		},

		/**
		 * 复制到剪贴板
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.text 复制的文本
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		copyToClipborad (obj: copyToClipboradParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.copyToClipborad.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.copyToClipborad(JSON.stringify(obj));
			}
		},
		
		// 去积分商城
		goIntegralMall (): void {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goIntegralMall.postMessage('');
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.goIntegralMall();
			}
		},

        /**
		 * 去积分任务
		 */
		goIntegralTask (): void {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goIntegralTask.postMessage('');
			}
			if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.goIntegralTask();
			}
		},

		// 返回
		Back (): void {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.Back.postMessage('');
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.back();
			}
		},
		
		/**
		 * 海报分享
		 * @param  {string} obj.image base64字符串
		 * @param  {string} obj.title 标题
		 * @param  {string} obj.desc 描述
		 * @param  {string} obj.link 链接
		 * @param  {string} obj.imgUrl 小图标
		 * @param  {string} obj.callback 回调函数名 (返回对象有status --状态 和 origin --渠道)
		 */
		shareImage (obj: shareImageParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.shareImage.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.shareImage(JSON.stringify(obj));
			}
		},

        // 加积分
        integral (obj: integralParams): void {
			if (obj.callback) {
                let funName = generateFnName()
                window[funName] = obj.callback
                obj.callback = funName
            }
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.integral.postMessage(obj);
			} else if (COVERAPP.Attribute.isAndroid()) {
				window.AndroidBridging.integral(JSON.stringify(obj));
			}
		}
	},

	// ready方法 需要确保桥可以使用是，放在ready方法里
	ready (fn: any) {
		readyFnList.push(fn);
	}
};
window.COVERAPP_CallBack_ready = () => {
	for (let i = 0; i < readyFnList.length; ++i) {
		readyFnList[i].call();
	}
}

export default COVERAPP = COVERAPP;
